export const ageCalculator = (dob, timezone = 'UTC') => {
  // Get current date in specified timezone
  const options = { timeZone: timezone };
  const todayStr = new Date().toLocaleString('en-US', options);
  const today = new Date(todayStr);
  
  // Parse birthdate in the specified timezone
  const birthDateStr = new Date(dob).toLocaleString('en-US', options);
  const birthDate = new Date(birthDateStr);
  
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age -= 1;
  return age;
};


export const yearCalculator = (startDate, endDate = null, timezone = 'UTC') => {
  // Get dates in specified timezone
  const options = { timeZone: timezone };
  
  // Parse start date in specified timezone
  const startDateStr = new Date(startDate).toLocaleString('en-US', options);
  const start_date = new Date(startDateStr);
  
  // Parse end date in specified timezone
  let end_date;
  if (endDate) {
    const endDateStr = new Date(endDate).toLocaleString('en-US', options);
    end_date = new Date(endDateStr);
  } else {
    const nowStr = new Date().toLocaleString('en-US', options);
    end_date = new Date(nowStr);
  }

  let calcYears = end_date.getFullYear() - start_date.getFullYear();
  let monthDiff = end_date.getMonth() - start_date.getMonth();
  let dayDiff = end_date.getDate() - start_date.getDate();

  // Adjust for the current day
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    calcYears--;
  }

  return calcYears;
};
